import { App, AppActions } from '@nab/x-types';
import { createActionsForAppInstance } from '@nab/x-registries';
import { defaultActionsProvider } from './defaultActionsProvider';

const createActionsForApp = (app: App, instanceId: string): AppActions => {
    return createActionsForAppInstance(app, instanceId, defaultActionsProvider);
};

export { createActionsForApp };
